module.exports = __webpack_public_path__ + "img/engine-speed.0081d2d8.svg";